import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: 'Will I be hungry?',
    a: 'You\'ll feel "empty" rather than hungry. The nutrient-dense liquids keep your brain fueled and blood sugar stable.'
  }, {
    q: 'Is this a diet?',
    a: 'No. It is a 48-hour biological intervention for a specific short-term result, not a long-term lifestyle diet.'
  }, {
    q: 'Can I do this while working?',
    a: "Yes. The plan is designed to be discreet and simple for a busy professional. You won't need to spend hours in the kitchen."
  }, {
    q: 'What if I have coffee?',
    a: 'We recommend a 48-hour break for maximum results, but the plan includes a "modified" version if you absolutely can\'t skip it.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-stone-50" data-id="element-31">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-32">
        <div className="text-center mb-12" data-id="element-33">
          <h2 className="text-3xl md:text-4xl font-serif text-stone-900" data-id="element-34">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-4" data-id="element-35">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-stone-200 rounded-xl overflow-hidden transition-all duration-200" data-id="element-36">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-37">
                <span className="font-medium text-stone-900 text-lg" data-id="element-38">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-stone-400 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-39" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-40">
                <p className="text-stone-600 leading-relaxed" data-id="element-41">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}